import { useState } from 'react';
import { Box, Tabs, Tab } from '@mui/material';
import BusinessIcon from '@mui/icons-material/Business';
import CurrencyExchangeIcon from '@mui/icons-material/CurrencyExchange';
import OperatorList from './OperatorList';
import CurrencyList from './currency/CurrencyList';

/**
 * Operator Management wrapper — hosts two tabs:
 *   - Operators  → existing operator CRUD table
 *   - Currencies → display-currency catalogue (maps to internal SC/GC)
 *
 * Per product decision, currency management lives inside Operator Management
 * (no separate sidebar page).
 */
const OperatorManagement = () => {
  const [tab, setTab] = useState(0);

  return (
    <Box sx={{ p: 0 }}>
      <Box
        sx={{
          borderBottom: '1px solid rgba(255, 255, 255, 0.1)',
          backgroundColor: '#1A1A1A',
          px: 2
        }}
      >
        <Tabs
          value={tab}
          onChange={(_e, v) => setTab(v)}
          textColor="inherit"
          TabIndicatorProps={{ style: { backgroundColor: '#FFC107' } }}
          sx={{
            '& .MuiTab-root': {
              color: 'rgba(255,255,255,0.6)',
              textTransform: 'none',
              fontWeight: 600,
              minHeight: 56
            },
            '& .Mui-selected': { color: '#FFC107 !important' }
          }}
        >
          <Tab icon={<BusinessIcon fontSize="small" />} iconPosition="start" label="Operators" />
          <Tab
            icon={<CurrencyExchangeIcon fontSize="small" />}
            iconPosition="start"
            label="Currencies"
          />
        </Tabs>
      </Box>

      <Box hidden={tab !== 0}>{tab === 0 && <OperatorList />}</Box>
      <Box hidden={tab !== 1}>{tab === 1 && <CurrencyList />}</Box>
    </Box>
  );
};

export default OperatorManagement;
